import React, { useState } from 'react';
import {
  TableRow,
  TableCell,
  Tooltip,
  Avatar,
  IconButton
} from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';

// Components.
import AddAccoladeDialog from './modals/AddAccoladeDialog';
import ExpandableSectionWithTable from './components/ExpandableSectionWithTable';

const AccoladesSection = ({
  open,
  fetching,
  accolades,
  excludedAccolades,
  fetchExcludedAccolades,
  handleAddAccoladeToTeam,
  handleRemoveAccoladeFromTeam
}) => {
  const [openAddDialog, setOpenAddDialog] = useState(false);

  const handleOpenDialog = () => setOpenAddDialog(true);

  const handleCloseDialog = () => setOpenAddDialog(false);

  const headCells = [
    { id: 'id', numeric: false, disablePadding: false, label: 'Id', sortable: true },
    { id: 'logo', numeric: false, disablePadding: false, label: 'Logo', sortable: true },
    { id: 'outlet', numeric: false, disablePadding: false, label: 'Outlet', sortable: true },
    { id: 'accolade', numeric: false, disablePadding: false, label: 'Accolade' },
    { id: 'year', numeric: false, disablePadding: false, label: 'Year' },
    { id: 'associated', numeric: false, disablePadding: false, label: 'Associated' },
    { id: 'options', numeric: false, disablePadding: false, label: null },
  ];

  const RowRenderer = (row, _isSelected, _index, _handleCheck) => (
    <TableRow
      hover
      tabIndex={-1}
      key={row.id}
      style={{cursor: 'pointer'}}
      onClick={() => (row.id)}
    >
      <TableCell>{row.id}</TableCell>
      <TableCell>
        <Avatar src={row.logo} alt={row.outlet}>
          {row.outlet?.[0]}
        </Avatar>
      </TableCell>
      <TableCell>{row.outlet}</TableCell>
      <TableCell>{row.description}</TableCell>
      <TableCell>{row.year}</TableCell>
      <TableCell>{row.associated}</TableCell>
      <TableCell style={{display: 'flex'}}>
        <Tooltip title={'Delete'}>
          <IconButton edge='end' aria-label='delete' onClick={() => handleRemoveAccoladeFromTeam(row.id)}>
            <DeleteIcon />
          </IconButton>
        </Tooltip>
      </TableCell>
    </TableRow>
  );

  return (
    <>
      <ExpandableSectionWithTable
        title='Accolades'
        open={open}
        fetching={fetching}
        headCells={headCells}
        rows={accolades || []}
        RowRenderer={RowRenderer}
        onAddNew={handleOpenDialog}
        addButtonLabel='Add Accolade'
      />
      <AddAccoladeDialog
        open={openAddDialog}
        onClose={handleCloseDialog}
        excludedAccolades={excludedAccolades}
        fetchExcludedAccolades={fetchExcludedAccolades}
        handleAddAccoladeToTeam={handleAddAccoladeToTeam}
      />
    </>
  );
};

export default AccoladesSection;
